var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-view",style:(_vm.styleView)},[(_vm.title)?_c('div',{staticClass:"cv-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"cv-content custom-scrollbar",class:[_vm.border ? '' : 'bd-0', ..._vm.flexClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }